import PropTypes from 'prop-types';
import { NewBookingDeliveryPropType } from 'common/prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import _sumBy from 'lodash/sumBy';
import {
  bulkUploadGroupingClusterMappingsSelector,
  bulkUploadGroupingFetchingQuoteSelector,
} from 'selectors/new-bulk-upload-selectors';
import RouteOptimizationModal from './route-optimization-modal';

const RouteOptimizationModalDisplay = ({
  deliveries,
  totalAmount,
  optimizedTotalAmount,
  isShowRouteOptimizationModal,
  dontShowGroupingOptimizeModal,
  onOkRouteOptimizationModal,
  onCancelRouteOptimizationModal,
}) => {
  const bulkUploadGroupingClusterMappings = useSelector(
    bulkUploadGroupingClusterMappingsSelector,
  );
  const bulkUploadFetchingGroupQuote = useSelector(
    bulkUploadGroupingFetchingQuoteSelector,
  );

  if (dontShowGroupingOptimizeModal || bulkUploadFetchingGroupQuote) {
    return null;
  }

  const deliveryCount = _sumBy(
    bulkUploadGroupingClusterMappings,
    mapping => _get(mapping, 'originalDeliveryIDs', []).length,
  );
  if (deliveryCount === 0) {
    return null;
  }
  const currency = _get(deliveries[0], 'quote.currency');
  if (!currency) {
    return null;
  }
  return (
    <RouteOptimizationModal
      visible={isShowRouteOptimizationModal}
      numDeliveries={deliveryCount}
      optimizedAmount={optimizedTotalAmount}
      currentAmount={totalAmount}
      currency={currency}
      onOk={onOkRouteOptimizationModal}
      onCancel={onCancelRouteOptimizationModal}
    />
  );
};

RouteOptimizationModalDisplay.defaultProps = {};

RouteOptimizationModalDisplay.propTypes = {
  deliveries: PropTypes.arrayOf(NewBookingDeliveryPropType).isRequired,
  totalAmount: PropTypes.number.isRequired,
  optimizedTotalAmount: PropTypes.number.isRequired,
  isShowRouteOptimizationModal: PropTypes.bool.isRequired,
  dontShowGroupingOptimizeModal: PropTypes.bool.isRequired,
  onOkRouteOptimizationModal: PropTypes.func.isRequired,
  onCancelRouteOptimizationModal: PropTypes.func.isRequired,
};

export default RouteOptimizationModalDisplay;
